export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "Company",
      services: "Services",
      projects: "Projects",
      clients: "Clientele",
      contact: "Contact",
    },
    hero: {
      eyebrow: "Civil Engineering · Miami, FL · Est. 2015",
      title_1: "Engineering",
      title_2: "the ground beneath",
      title_3: "Miami's growth.",
      lede:
        "josengineer is a privately owned Civil Engineering firm and licensed Testing Laboratory. We take projects from inception through design, permitting, and construction — built around your budget and schedule.",
      cta_primary: "Start a project",
      cta_secondary: "Our services",
      meta_a: "Founded by Jose A. Salas",
      meta_b: "Public & private sector",
    },
    about: {
      eyebrow: "About the firm",
      title: "A practical approach to civil engineering.",
      body_1:
        "Established in August 2015 by Jose A. Salas, josengineer focuses on Land Development, Environmental, and Water Resources engineering across South Florida. We service both public and private sector clients.",
      body_2:
        "We implement strong project management and constructability in our designs — considering client budget and schedule first. From inception through construction, our work is grounded in clarity, code, and craftsmanship.",
      stat_1: "Year founded",
      stat_2: "Core disciplines",
      stat_3: "Sectors served",
      stat_3_value: "Public + Private",
    },
    services: {
      eyebrow: "What we do",
      title: "Three disciplines. One disciplined practice.",
      sub:
        "Each engagement is led by licensed engineering and supported by an in-house testing laboratory.",
      items: [
        {
          tag: "01",
          title: "Land Development",
          body:
            "Site civil design, grading, drainage, paving, utilities, and permitting for commercial, residential, and mixed-use parcels across South Florida.",
        },
        {
          tag: "02",
          title: "Environmental",
          body:
            "Environmental assessments, contamination assessments, remediation planning, and regulatory coordination with DERM, FDEP, and EPA.",
        },
        {
          tag: "03",
          title: "Water Resources",
          body:
            "Stormwater management, drainage modeling, water/wastewater design, and SFWMD/SWFWMD permitting for resilient site hydrology.",
        },
      ],
      footer: "Need something adjacent? Ask. We collaborate with trusted MEP and structural partners.",
    },
    clients: {
      eyebrow: "Who we work with",
      title: "Trusted by builders across the building lifecycle.",
      list: [
        "Architectural Firms",
        "Mechanical Engineers",
        "Electrical Engineers",
        "Plumbing Designers",
        "Private Developers",
        "General Contractors",
        "Roof Contractors",
      ],
    },
    projects: {
      eyebrow: "Field documentation",
      title: "Recent projects from the field.",
      sub:
        "Inspections, manhole rehab, smoke testing, and site assessments documented across South Florida.",
    },
    contact: {
      eyebrow: "Get in touch",
      title: "Let's talk about your site.",
      sub:
        "Send us the basics — site address, scope, and timeline. You'll hear back from Jose directly.",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        message: "Project details",
        submit: "Send inquiry",
        sent: "Thanks — we received your message and will be in touch shortly.",
      },
      details_title: "Office",
      address: "16804 SW 109 CT, Miami, FL 33157",
      phone_label: "Phone",
      email_label: "Email",
      hours_label: "Hours",
      hours_value: "Mon – Fri · 8:00 AM – 6:00 PM EST",
    },
    footer: {
      tagline:
        "Civil Engineering, Land Development, Environmental & Water Resources.",
      rights: "All rights reserved.",
      built: "Built in Miami.",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      about: "Compañía",
      services: "Servicios",
      projects: "Proyectos",
      clients: "Clientes",
      contact: "Contacto",
    },
    hero: {
      eyebrow: "Ingeniería Civil · Miami, FL · Desde 2015",
      title_1: "Diseñamos",
      title_2: "el terreno donde",
      title_3: "Miami crece.",
      lede:
        "josengineer es una firma privada de Ingeniería Civil y Laboratorio de Pruebas autorizado. Llevamos proyectos desde la concepción hasta diseño, permisos y construcción — siempre en torno a su presupuesto y cronograma.",
      cta_primary: "Iniciar un proyecto",
      cta_secondary: "Nuestros servicios",
      meta_a: "Fundada por Jose A. Salas",
      meta_b: "Sector público y privado",
    },
    about: {
      eyebrow: "Sobre la firma",
      title: "Un enfoque práctico de la ingeniería civil.",
      body_1:
        "Establecida en agosto de 2015 por Jose A. Salas, josengineer se enfoca en Desarrollo de Terrenos, Ingeniería Ambiental y Recursos Hídricos en el sur de la Florida. Atendemos clientes del sector público y privado.",
      body_2:
        "Implementamos una sólida gestión de proyectos y constructibilidad en nuestros diseños, considerando primero el presupuesto y el cronograma del cliente. Desde la concepción hasta la construcción, nuestro trabajo se basa en claridad, normativa y oficio.",
      stat_1: "Año de fundación",
      stat_2: "Disciplinas centrales",
      stat_3: "Sectores atendidos",
      stat_3_value: "Público + Privado",
    },
    services: {
      eyebrow: "Qué hacemos",
      title: "Tres disciplinas. Una práctica disciplinada.",
      sub:
        "Cada proyecto es liderado por ingeniería licenciada y respaldado por nuestro laboratorio de pruebas interno.",
      items: [
        {
          tag: "01",
          title: "Desarrollo de Terrenos",
          body:
            "Diseño civil de sitio, nivelación, drenaje, pavimentación, servicios y permisos para parcelas comerciales, residenciales y de uso mixto en el sur de la Florida.",
        },
        {
          tag: "02",
          title: "Ambiental",
          body:
            "Evaluaciones ambientales, evaluación de contaminación, planificación de remediación y coordinación regulatoria con DERM, FDEP y EPA.",
        },
        {
          tag: "03",
          title: "Recursos Hídricos",
          body:
            "Gestión de aguas pluviales, modelado de drenaje, diseño de agua/aguas residuales y permisos SFWMD/SWFWMD para una hidrología resiliente del sitio.",
        },
      ],
      footer: "¿Necesita algo más? Consúltenos. Colaboramos con socios confiables MEP y estructurales.",
    },
    clients: {
      eyebrow: "Con quién trabajamos",
      title: "La confianza de quienes construyen, en cada etapa.",
      list: [
        "Firmas de Arquitectura",
        "Ingenieros Mecánicos",
        "Ingenieros Eléctricos",
        "Diseñadores de Plomería",
        "Desarrolladores Privados",
        "Contratistas Generales",
        "Contratistas de Techos",
      ],
    },
    projects: {
      eyebrow: "Documentación de campo",
      title: "Proyectos recientes desde el sitio.",
      sub:
        "Inspecciones, rehabilitación de pozos, pruebas de humo y evaluaciones de sitio documentadas en el sur de la Florida.",
    },
    contact: {
      eyebrow: "Contáctenos",
      title: "Hablemos de su proyecto.",
      sub:
        "Envíenos lo esencial — dirección del sitio, alcance y cronograma. Jose le responderá personalmente.",
      form: {
        name: "Nombre",
        email: "Correo",
        phone: "Teléfono",
        message: "Detalles del proyecto",
        submit: "Enviar solicitud",
        sent:
          "Gracias — hemos recibido su mensaje y nos pondremos en contacto pronto.",
      },
      details_title: "Oficina",
      address: "16804 SW 109 CT, Miami, FL 33157",
      phone_label: "Teléfono",
      email_label: "Correo",
      hours_label: "Horario",
      hours_value: "Lun – Vie · 8:00 AM – 6:00 PM EST",
    },
    footer: {
      tagline:
        "Ingeniería Civil, Desarrollo de Terrenos, Ambiental y Recursos Hídricos.",
      rights: "Todos los derechos reservados.",
      built: "Hecho en Miami.",
    },
  },
};
